import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'

export interface IDeleteAppointmentActivityReturn {
  appointmentUuid: string
}

export const deleteAppointmentActivity = createAsyncThunk<
  IDeleteAppointmentActivityReturn,
  { appointmentUuid: string; activityUuid: string },
  IThunkReject<any>
>('appointment/activity/delete', async (payload, { rejectWithValue }) => {
  const { appointmentUuid, activityUuid } = payload
  let apiData: null | IDeleteAppointmentActivityReturn = null

  try {
    const promise = clientSDK
      .instance()
      .delete(
        `calendar/appointments/${appointmentUuid}/appointment-activities/${activityUuid}`,
      )
    const result = await promise
    apiData = { appointmentUuid }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
